(function() {
  var cartTriggers = document.querySelectorAll('[data-animation-cart-drawer-trigger]');

  if (!cartTriggers.length) {
    return;
  }

  cartTriggers.forEach(function(cartTrigger) {
    if (cartTrigger.dataset.cartTriggerReady === 'true') {
      return;
    }

    cartTrigger.dataset.cartTriggerReady = 'true';
    cartTrigger.addEventListener('click', function() {
      var cartDrawer = document.querySelector('cart-drawer-component');

      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
        return;
      }

      window.location.href = window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart' : '/cart';
    });
  });
})();
